import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Forces from '../common/Forces';

export default class SomeSprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Sauce_1_Top);

    this.setOrigin(0);

    this.completeCallback = null;
    this.fade = false;
    this.rotate = false;

    this.mass = 1.0;
    this.gravity = 0;
    this.k = 0.0;

    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();
    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();

    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
  }

  reset (x, y, vx, vy, framename, alpha = 1, rotation = 0, scaleX = 1, scaleY = 1, regX = 0.5, regY = 0.5, lifetime = 10000, destX, destY) {
    this.pos.x = x;
    this.pos.y = y;
    this.vel.x = vx;
    this.vel.y = vy;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.scale = 0.8;

    this.destX = destX;
    this.destY = destY;

    this.setFrame(framename);

    this.setOrigin(regX, regY);

    this.update();

    this.alpha = alpha;
    this.angle = rotation;
    this.scaleX = scaleX;
    this.scaleY = scaleY;
  }

  update () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt, y: this.vel.y * dt });
    if (this.rotate) this.angle += this.vel.x * dt;
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);
    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;

    if (this.fade && this.age > this.halflife) {
      this.alpha -= 0.8 * dt;
    }
    return this.age < this.lifetime;
  }
}